var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryTradie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-608.000000, -810.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.000000, 127.000000)",
    id: "construction-sign"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.695652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9130435,14.2608696 L13.9130435,0.347826087 C13.9130435,0.155727044 13.7573164,0 13.5652174,0 L12.173913,0 C11.981814,0 11.826087,0.155727044 11.826087,0.347826087 L11.826087,14.2608696 L13.9130435,14.2608696 Z",
    id: "Path",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17391304,14.2608696 L4.17391304,0.347826087 C4.17391304,0.155727044 4.018186,0 3.82608696,0 L2.43478261,0 C2.24268357,0 2.08695652,0.155727044 2.08695652,0.347826087 L2.08695652,14.2608696 L4.17391304,14.2608696 Z",
    id: "Path",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 0.695652174,
    y: 14.2608696,
    width: 4.86956522,
    height: 1.04347826
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 10.4347826,
    y: 14.2608696,
    width: 4.86956522,
    height: 1.04347826
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 2.08695652,
    y: 8.34782609,
    width: 2.08695652,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 11.826087,
    y: 8.34782609,
    width: 2.08695652,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521739,1.39130435 L0.347826087,1.39130435 C0.155727044,1.39130435 0,1.54703139 0,1.73913043 L0,8 C0,8.19209904 0.155727044,8.34782609 0.347826087,8.34782609 L15.6521739,8.34782609 C15.844273,8.34782609 16,8.19209904 16,8 L16,1.73913043 C16,1.54703139 15.844273,1.39130435 15.6521739,1.39130435 Z",
    id: "Path",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.695652174,
    y: 2.08695652,
    width: 14.6086957,
    height: 5.56521739
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3043478,5.22991304 L12.173913,2.09947826 L15.3043478,2.09947826 L15.3043478,5.22991304 Z M6.60869565,2.09947826 L9.39130435,2.09947826 L14.9565217,7.66469565 L12.173913,7.66469565 L6.60869565,2.09947826 Z M9.39130435,7.66469565 L6.60869565,7.66469565 L1.04347826,2.09947826 L3.82608696,2.09947826 L9.39130435,7.66469565 Z M0.695652174,4.53426087 L3.82608696,7.66469565 L0.695652174,7.66469565 L0.695652174,4.53426087 Z",
    id: "Shape",
    fill: "#ED7064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17391304,1.39130435 L2.07513043,1.39130435 L2.07513043,0.347826087 C2.07513043,0.155727044 2.23085748,0 2.42295652,0 L3.82608696,0 C4.018186,0 4.17391304,0.155727044 4.17391304,0.347826087 L4.17391304,1.39130435 Z",
    id: "Path",
    fill: "#FFD764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9130435,1.39130435 L11.8142609,1.39130435 L11.8142609,0.347826087 C11.8142609,0.155727044 11.9699879,0 12.162087,0 L13.5652174,0 C13.7573164,0 13.9130435,0.155727044 13.9130435,0.347826087 L13.9130435,1.39130435 Z",
    id: "Path",
    fill: "#FFD764"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTradie);
export default __webpack_public_path__ + "static/media/category_tradie.2a922a12cbdb400870d87b925c8ff691.svg";
export { ForwardRef as ReactComponent };